export function calledBy(
  who: { handle: string; displayName?: string | null } | null | undefined,
): string | null {
  if (!who) return null;
  const said = who.displayName?.trim();
  if (said) return said;
  return who.handle.charAt(0).toUpperCase() + who.handle.slice(1);
}
